import { render, staticRenderFns } from "./PlanningWrapper.vue?vue&type=template&id=0f7d80dc&scoped=true&lang=pug&"
import script from "./PlanningWrapper.vue?vue&type=script&lang=ts&"
export * from "./PlanningWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningWrapper.vue?vue&type=style&index=0&id=0f7d80dc&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7d80dc",
  null
  
)

export default component.exports